import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type BookingListItem = ResultOf<
  typeof bookingListQuery
>["bookings"]["data"][number];

export const bookingListQuery = graphql(`
  query BookingList(
    $first: Int!
    $page: Int
    $orderBy: [QueryBookingsOrderByRelationOrderByClause!]
    $status: [BookingStatus!]
    $relocationId: ID
    $supplierId: ID
    $search: String
    $whereRelocation: QueryBookingsWhereRelocationWhereHasConditions
    $where: QueryBookingsWhereWhereConditions
    $departureCityIds: [ID!]
    $deliveryCityIds: [ID!]
    $vehicleIds: [ID!]
    $relocationType: [RelocationType!]
    $hasNoCustomerPayments: Boolean
    $hasMatches: BookingRelocationMatchType
  ) {
    bookings(
      page: $page
      first: $first
      orderBy: $orderBy
      status: $status
      relocation_id: $relocationId
      supplier_id: $supplierId
      search: $search
      where: $where
      whereRelocation: $whereRelocation
      delivery_city_id: $deliveryCityIds
      departure_city_id: $departureCityIds
      vehicle_id: $vehicleIds
      relocation_type: $relocationType
      hasNoCustomerPayments: $hasNoCustomerPayments
      hasMatches: $hasMatches
    ) {
      data {
        id
        uuid
        reference
        currency
        customer_url
        name
        email
        phone
        status
        distance_allowed
        currency
        date_of_birth
        created_at
        depart_at
        deliver_at
        supplier_reference
        number_of_travellers
        discounted_units
        full_price_units
        customer_note
        relocation {
          id
          type
          hire_unit_type
          measurement
          currency
          distance_allowed
          available_from_date
          available_to_date
          hire_units_allowed
          extra_hire_units_allowed
          reference
          customer_url
        }
        supplier {
          id
          name
          ...SupplierIconFields
        }
        vehicle {
          id
          name
          type
        }
        departureOffice {
          id
          name
          city_id
        }
        deliveryOffice {
          id
          name
          city_id
        }
        inclusions {
          id
          type
          description
          value
          has_free_tank
        }

        relocationLine {
          id
          reference
          created_at
          sold_at
          group {
            id
            expires_at
          }
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
